import React from "react";
import {
    FileInput,
    Classes,
    Dialog,
    Button,
    FormGroup,
    Intent
} from "@blueprintjs/core";

class DialogAddChannel extends React.Component {


    render() {
        const {
            newCriterias,
            dialogIsOpen,
            submiting,
            onCloseDialog,
            onChangeInputFile,
            onAddCriteria
        } = this.props;

        return (
            <Dialog
                icon="add"
                title="Add fixed channel"
                autoFocus={true}
                canEscapeKeyClose={true}
                canOutsideClickClose={true}
                usePortal={true}
                enforceFocus={true}
                isOpen={dialogIsOpen}
                onClose={onCloseDialog}
            >
                <div className={Classes.DIALOG_BODY}>
                    <FormGroup
                        label="Image"
                        labelFor="criteria-file"
                        disabled={submiting}
                    >
                        <FileInput
                            id="criteria-file"
                            fill={true}
                            inputProps={{ name: "file", multiple: true }}
                            onInputChange={onChangeInputFile}
                            disabled={submiting}
                            text={"Add image..."}
                        />
                    </FormGroup>
                </div>
                {newCriterias.length > 0 &&
                    <div className='large-hoz-padding margin-bottom-large'>
                        {newCriterias.map((resource, i) => <span key={i}>{resource.name} <br /></span>)}
                    </div>
                }
                <div className={Classes.DIALOG_FOOTER}>
                    <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                        <Button onClick={onCloseDialog} text="Cancel" />
                        <Button
                            onClick={onAddCriteria}
                            text="Download"
                            disabled={
                                submiting || newCriterias.length === 0
                            }
                            loading={submiting}
                            intent={Intent.SUCCESS}
                            rightIcon="add"
                        />
                    </div>
                </div>
            </Dialog>
        );
    }
}

export default DialogAddChannel;
